export function filterBranch(branches: any[]): any[] {
  return branches?.filter((branch) => branch.id > 0) ?? [];
}

export function getBranchNamebyId(branchId: number, branches: any[]): string {
  return branches?.find((branch) => branch.id == branchId)?.name;
}
